import PropTypes from 'prop-types';
import styles from './Section.module.scss';

/**
 * A simple component to break up content into different sections
 */
export default function Section({ children }) {
  return (
    <div className={styles.section}>
      {children}
    </div>
  );
}

Section.propTypes = {
  /**
   * What goes in the Section
   */
  children: PropTypes.node.isRequired,
};
